<template>
    <div>
      <annuity-detail-status-list></annuity-detail-status-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  